(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

    }



    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =

        this.getAttribute('data-sticky-type') === 'always' ||

        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};



      this.setHeaderHeight();



      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));



      if (this.headerIsAlwaysSticky) {

        this.header.classList.add('shopify-section-header-sticky');

      }



      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();

      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }

    }



    setHeaderHeight() {

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

    }



    disconnectedCallback() {

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();

    }



    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {

            this.preventReveal = false;

          }, 66);



          requestAnimationFrame(this.hide.bind(this));

        }

      } else if (scrollTop <= this.headerBounds.top) {

        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }



    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());

    }



    closeSearchModal() {

      this.searchDrawer = this.searchDrawer || this.header.querySelector('omri-search-drawer');

      if (this.searchDrawer && typeof this.searchDrawer.close === 'function') {

        this.searchDrawer.close(false);

      }

    }

  }



  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omri-comment-ca-marche"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('omri-how-it-works')) return;

  class OmriHowItWorks extends HTMLElement {
    constructor() {
      super();
      this.current = 0;
      this.userPaused = false;
      this.blocked = false;
      this.completed = false;
      this.request = 0;
      this.frame = 0;
      this.entries = [];
    }

    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.rail = this.querySelector('[data-how-rail]');
      if (!this.rail) { this.connected = false; return; }
      this.events = new AbortController();
      const signal = this.events.signal;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.status = this.querySelector('[data-how-status]');
      this.cards = [...this.querySelectorAll('[data-how-card]')];
      this.dots = [...this.querySelectorAll('[data-how-dot]')];
      this.entries = [...this.querySelectorAll('[data-how-entry]')].map(frame => ({
        frame,
        video: frame.querySelector('[data-how-video]'),
        button: frame.querySelector('[data-how-toggle]'),
        playing: false,
        pending: false
      })).filter(entry => entry.video && entry.button);
      this.current = Math.min(this.current, Math.max(0, this.entries.length - 1));

      this.entries.forEach((entry, index) => {
        entry.video.muted = true;
        entry.video.defaultMuted = true;
        entry.video.playsInline = true;
        entry.button.hidden = false;
        this.showPoster(entry);
        entry.button.addEventListener('click', () => {
          if (index === this.current && (entry.playing || entry.pending || !entry.video.paused)) {
            this.userPaused = true;
            this.stop();
          } else {
            this.userPaused = false;
            this.blocked = false;
            this.current = index;
            this.start(true);
          }
        }, { signal });
        entry.video.addEventListener('playing', () => {
          if (!this.connected || entry !== this.entries[this.current] || entry.video.paused || this.userPaused || document.hidden || !this.inViewport) {
            entry.video.pause();
            this.showPoster(entry);
            return;
          }
          entry.pending = false;
          entry.playing = true;
          entry.frame.classList.add('is-playing');
          this.syncButton(entry);
        }, { signal });
        entry.video.addEventListener('pause', () => {
          if (entry.video.paused) this.showPoster(entry);
        }, { signal });
        entry.video.addEventListener('ended', () => {
          this.showPoster(entry);
          if (entry !== this.entries[this.current]) return;
          if (this.current === this.entries.length - 1) {
            this.completed = true;
            return;
          }
          if (this.completed || this.reduced.matches || this.userPaused) return;
          this.current += 1;
          this.resume();
        }, { signal });
        entry.video.addEventListener('error', () => {
          this.showPoster(entry);
          if (entry === this.entries[this.current]) { this.blocked = true; this.stop(); }
          if (this.status) this.status.textContent = 'La vidéo est indisponible. Vous pouvez consulter son aperçu.';
        }, { signal });
      });

      this.inViewport = false;
      this.autoVisible = false;
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.inViewport = entry.isIntersecting;
          this.autoVisible = entry.isIntersecting && entry.intersectionRatio >= .35;
          if (!this.inViewport) this.stop();
          else if (this.autoVisible) this.resume();
        }, { threshold: [0, .35] });
        this.visibility.observe(this.rail);
      } else {
        this.inViewport = true;
        this.autoVisible = true;
        this.resume();
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.resume();
      }, { signal });
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.stop();
        else this.resume();
      }, { signal });
      this.mobile.addEventListener('change', () => this.updateRail(), { signal });
      window.addEventListener('resize', () => this.scheduleRail(), { passive: true, signal });
      this.rail.addEventListener('scroll', () => this.scheduleRail(), { passive: true, signal });
      this.rail.addEventListener('keydown', event => this.onRailKey(event), { signal });
      this.bindCTA(signal);
      this.updateRail();
    }

    syncButton(entry) {
      const playing = entry.playing || entry.pending;
      entry.button.setAttribute('aria-label', playing ? entry.button.dataset.pauseLabel : entry.button.dataset.playLabel);
      const icon = entry.button.querySelector('[data-how-icon]');
      if (icon) icon.setAttribute('d', playing ? 'M4.5 3h2.3v10H4.5zm4.7 0h2.3v10H9.2z' : 'M5 3.2 12 8l-7 4.8z');
    }

    showPoster(entry) {
      entry.playing = false;
      entry.pending = false;
      entry.frame.classList.remove('is-playing');
      this.syncButton(entry);
    }

    stop() {
      this.request += 1;
      this.entries.forEach(entry => {
        entry.video.pause();
        this.showPoster(entry);
      });
    }

    resume() {
      if (!this.connected || !this.autoVisible || document.hidden || this.userPaused || this.blocked || this.completed || this.reduced.matches) return;
      const entry = this.entries[this.current];
      if (entry && !entry.video.ended && !entry.playing && !entry.pending) this.start(false);
    }

    start(manual) {
      if (!this.connected || document.hidden) return;
      if (!manual && (this.userPaused || this.blocked || this.completed || this.reduced.matches || !this.autoVisible)) return;
      const entry = this.entries[this.current];
      if (!entry) return;
      if (!manual && entry.video.ended) return;
      if (manual && !this.inViewport) {
        const rect = entry.frame.getBoundingClientRect();
        this.inViewport = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      }
      if (!this.inViewport) return;
      this.stop();
      const request = this.request;
      if (this.status) this.status.textContent = '';
      if (entry.video.ended) {
        try { entry.video.currentTime = 0; } catch (_) { /* Métadonnées pas encore prêtes. */ }
      }
      entry.pending = true;
      this.syncButton(entry);
      let promise;
      try { promise = entry.video.play(); }
      catch (error) { this.playFailed(entry, request, manual); return; }
      if (promise?.catch) promise.catch(() => this.playFailed(entry, request, manual));
    }

    playFailed(entry, request, manual) {
      if (!this.connected || request !== this.request || entry !== this.entries[this.current]) return;
      this.blocked = true;
      this.stop();
      if (manual && this.status) this.status.textContent = 'La vidéo n’a pas pu démarrer. Réessayez avec le bouton de lecture.';
    }

    scheduleRail() {
      if (this.frame || !this.connected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.connected) this.updateRail(); });
    }

    nearestCard() {
      const edge = this.rail.getBoundingClientRect().left;
      let nearest = 0, distance = Infinity;
      this.cards.forEach((card, index) => {
        const value = Math.abs(card.getBoundingClientRect().left - edge);
        if (value < distance) { nearest = index; distance = value; }
      });
      return nearest;
    }

    updateRail() {
      this.rail.tabIndex = this.mobile.matches ? 0 : -1;
      const active = this.mobile.matches ? this.nearestCard() : 0;
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    }

    onRailKey(event) {
      if (event.target !== this.rail || !this.mobile.matches || event.altKey || event.ctrlKey || event.metaKey) return;
      let index = this.nearestCard();
      if (event.key === 'ArrowRight') index += 1;
      else if (event.key === 'ArrowLeft') index -= 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = this.cards.length - 1;
      else return;
      event.preventDefault();
      index = Math.max(0, Math.min(this.cards.length - 1, index));
      if (this.cards[index]) this.rail.scrollTo({
        left: this.cards[index].offsetLeft - this.cards[0].offsetLeft,
        behavior: this.reduced.matches ? 'instant' : 'smooth'
      });
    }

    bindCTA(signal) {
      const link = this.querySelector('[data-how-auto-cta]');
      if (!link) return;
      link.addEventListener('click', event => {
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const form = document.querySelector('[id^="omri-custom-order-"]');
        if (!form) return;
        event.preventDefault();
        const header = document.querySelector('.section-header');
        const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 16;
        window.scrollTo({ top: Math.max(0, window.scrollY + form.getBoundingClientRect().top - offset), behavior: this.reduced.matches ? 'instant' : 'smooth' });
        if (event.detail === 0) {
          const target = form.querySelector('h1,h2') || form;
          const previous = target.getAttribute('tabindex');
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          target.addEventListener('blur', () => {
            if (previous === null) target.removeAttribute('tabindex');
            else target.setAttribute('tabindex', previous);
          }, { once: true });
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.connected = false;
      this.events?.abort();
      this.visibility?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.stop();
      this.entries.forEach(entry => { entry.button.hidden = true; });
    }
  }

  customElements.define('omri-how-it-works', OmriHowItWorks);
})();

(() => {
  'use strict';
  if (customElements.get('omri-how-accordion')) return;

  class OmriHowAccordion extends HTMLElement {
    constructor() { super(); this.active = 0; this.entries = []; }

    connectedCallback() {
      if (this.connected) return;
      this.stage = this.querySelector('[data-how-acc-stage]');
      if (!this.stage) return;
      this.connected = true;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.status = this.querySelector('[data-how-acc-status]');
      this.entries = [...this.querySelectorAll('[data-how-acc-item]')].map(item => ({
        item,
        trigger: item.querySelector('[data-how-acc-trigger]'),
        body: item.querySelector('[data-how-acc-body]'),
        slot: item.querySelector('[data-how-acc-slot]'),
        media: item.querySelector('[data-how-acc-media]'),
        video: item.querySelector('[data-how-acc-video]'),
        toggle: item.querySelector('[data-how-acc-toggle]'),
        poster: item.querySelector('[data-how-acc-poster]'),
        pausedByUser: false, blocked: false, playing: false, pending: false,
        visible: false, request: 0, timer: 0
      })).filter(entry => entry.trigger && entry.body && entry.slot && entry.media);
      this.active = Math.min(this.active, Math.max(0, this.entries.length - 1));

      this.entries.forEach((entry, index) => {
        entry.trigger.addEventListener('click', () => this.activate(index), { signal });
        entry.trigger.addEventListener('keydown', event => {
          let target = index;
          if (event.key === 'ArrowDown') target = (index + 1) % this.entries.length;
          else if (event.key === 'ArrowUp') target = (index - 1 + this.entries.length) % this.entries.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = this.entries.length - 1;
          else return;
          event.preventDefault();
          this.entries[target].trigger.focus({ preventScroll: true });
        }, { signal });
        entry.body.addEventListener('transitionend', event => {
          if (event.target === entry.body && event.propertyName === 'grid-template-rows') this.settle(entry);
        }, { signal });
        entry.body.addEventListener('focusin', () => this.settle(entry), { signal });
        this.bindVideo(entry, index, signal);
        const image = entry.media.querySelector('img');
        if (image) image.addEventListener('error', () => {
          image.hidden = true;
          if (this.status && index === this.active) this.status.textContent = 'Le visuel est indisponible. Le texte de cette étape reste accessible.';
        }, { signal });
      });

      this.placeMedia();
      this.activate(this.active, false);
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(records => {
          records.forEach(record => {
            const entry = this.entries.find(candidate => candidate.media === record.target);
            if (!entry) return;
            entry.visible = record.isIntersecting && record.intersectionRatio >= .15;
            if (!entry.visible) this.pause(entry);
          });
          this.resume();
        }, { threshold: [0, .15] });
        this.entries.forEach(entry => this.visibility.observe(entry.media));
      } else {
        this.checkVisibility();
        window.addEventListener('scroll', () => this.checkVisibility(), { passive: true, signal });
      }
      this.desktop.addEventListener('change', () => {
        this.entries.forEach(entry => this.pause(entry));
        this.placeMedia();
        this.entries.forEach(entry => this.settle(entry));
        this.checkVisibility();
      }, { signal });
      this.reduced.addEventListener('change', () => {
        this.entries.forEach(entry => { this.pause(entry); this.settle(entry); this.syncToggle(entry); });
        this.resume();
      }, { signal });
      window.addEventListener('resize', () => {
        this.entries.forEach(entry => this.settle(entry));
        if (!this.visibility) this.checkVisibility();
      }, { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.entries.forEach(entry => this.pause(entry));
        else this.resume();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.entries.findIndex(entry => entry.item.dataset.blockId && entry.item.dataset.blockId === String(event.detail?.blockId || ''));
        if (index >= 0) this.activate(index, false);
      }, { signal });
      this.bindCTA(signal);
    }

    activate(index, animate = true) {
      if (!this.connected || !this.entries[index]) return;
      this.active = index;
      this.entries.forEach((entry, position) => {
        const open = position === index;
        const wasOpen = entry.item.classList.contains('is-open');
        if (!open && (entry.body.contains(document.activeElement) || entry.media.contains(document.activeElement))) this.entries[index].trigger.focus({ preventScroll: true });
        entry.trigger.setAttribute('aria-expanded', String(open));
        if (open) entry.trigger.setAttribute('aria-disabled', 'true');
        else entry.trigger.removeAttribute('aria-disabled');
        entry.body.inert = !open;
        entry.media.inert = !open;
        entry.media.setAttribute('aria-hidden', String(!open));
        if (!open) entry.body.setAttribute('aria-hidden', 'true');
        else entry.body.removeAttribute('aria-hidden');
        entry.media.classList.toggle('is-active', open);
        clearTimeout(entry.timer);
        entry.timer = 0;
        if (open && entry.body.hidden) {
          entry.body.hidden = false;
          if (animate && !this.reduced.matches) entry.body.getBoundingClientRect();
        }
        entry.item.classList.toggle('is-open', open);
        if (!animate || this.reduced.matches || wasOpen === open) this.settle(entry);
        else entry.timer = setTimeout(() => this.settle(entry), this.transitionTime(entry.body) + 100);
        if (!open) this.pause(entry);
        if (open) {
          const image = entry.media.querySelector('img');
          if (image) image.loading = 'eager';
        }
      });
      this.checkVisibility();
    }

    transitionTime(element) {
      const css = getComputedStyle(element);
      const toMs = value => parseFloat(value) * (value.trim().endsWith('ms') ? 1 : 1000) || 0;
      const durations = css.transitionDuration.split(',').map(toMs);
      const delays = css.transitionDelay.split(',').map(toMs);
      return Math.max(0, ...durations.map((duration, index) => duration + delays[index % delays.length]));
    }

    settle(entry) {
      clearTimeout(entry.timer);
      entry.timer = 0;
      entry.body.style.transition = 'none';
      entry.body.hidden = !entry.item.classList.contains('is-open');
      entry.body.getBoundingClientRect();
      entry.body.style.removeProperty('transition');
    }

    placeMedia() {
      this.dataset.desktop = String(this.desktop.matches);
      this.entries.forEach(entry => (this.desktop.matches ? this.stage : entry.slot).appendChild(entry.media));
      this.stage.hidden = !this.desktop.matches;
    }

    bindVideo(entry, index, signal) {
      if (!entry.video || !entry.toggle) return;
      entry.video.muted = true;
      entry.video.defaultMuted = true;
      entry.video.playsInline = true;
      entry.video.loop = true;
      entry.toggle.addEventListener('click', () => {
        if (entry.playing || entry.pending || !entry.video.paused) {
          entry.pausedByUser = true;
          this.pause(entry);
        } else {
          entry.pausedByUser = false;
          entry.blocked = false;
          this.play(entry, true);
        }
      }, { signal });
      entry.video.addEventListener('playing', () => {
        if (!this.connected || index !== this.active || this.reduced.matches || document.hidden || entry.pausedByUser || entry.video.paused || !entry.visible) {
          this.pause(entry);
          return;
        }
        entry.pending = false;
        entry.playing = true;
        entry.media.classList.add('is-playing');
        this.syncToggle(entry);
      }, { signal });
      entry.video.addEventListener('pause', () => {
        if (entry.video.paused) { entry.playing = false; entry.pending = false; entry.media.classList.remove('is-playing'); this.syncToggle(entry); }
      }, { signal });
      entry.video.addEventListener('error', () => { entry.blocked = true; this.pause(entry); }, { signal });
      this.syncToggle(entry);
    }

    syncToggle(entry) {
      if (!entry.toggle) return;
      entry.toggle.hidden = this.reduced.matches;
      const playing = entry.playing || entry.pending;
      entry.toggle.setAttribute('aria-label', playing ? entry.toggle.dataset.pauseLabel : entry.toggle.dataset.playLabel);
      const icon = entry.toggle.querySelector('[data-how-icon]');
      if (icon) icon.setAttribute('d', playing ? 'M4.5 3h2.3v10H4.5zm4.7 0h2.3v10H9.2z' : 'M5 3.2 12 8l-7 4.8z');
    }

    pause(entry) {
      entry.request += 1;
      entry.video?.pause();
      entry.playing = false;
      entry.pending = false;
      entry.media.classList.remove('is-playing');
      this.syncToggle(entry);
    }

    play(entry, manual = false) {
      if (!entry.video || !this.connected || this.reduced.matches || document.hidden || !entry.visible || entry !== this.entries[this.active] || entry.playing || entry.pending) return;
      if (!manual && (entry.pausedByUser || entry.blocked)) return;
      entry.pending = true;
      const request = ++entry.request;
      this.syncToggle(entry);
      const failed = () => {
        if (!this.connected || request !== entry.request) return;
        entry.blocked = true;
        this.pause(entry);
      };
      try { const promise = entry.video.play(); if (promise?.catch) promise.catch(failed); }
      catch (_) { failed(); }
    }

    checkVisibility() {
      this.entries.forEach(entry => {
        const rect = entry.media.getBoundingClientRect();
        entry.visible = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      });
      this.resume();
    }

    resume() {
      const entry = this.entries[this.active];
      if (entry) this.play(entry);
    }

    bindCTA(signal) {
      const link = this.querySelector('[data-how-auto-cta]');
      if (!link) return;
      link.addEventListener('click', event => {
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const form = document.querySelector('[id^="omri-custom-order-"]');
        if (!form) return;
        event.preventDefault();
        const header = document.querySelector('.section-header');
        const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 16;
        window.scrollTo({ top: Math.max(0, window.scrollY + form.getBoundingClientRect().top - offset), behavior: this.reduced.matches ? 'instant' : 'smooth' });
        if (event.detail === 0) {
          const target = form.querySelector('h1,h2') || form;
          const previous = target.getAttribute('tabindex');
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          target.addEventListener('blur', () => {
            if (previous === null) target.removeAttribute('tabindex');
            else target.setAttribute('tabindex', previous);
          }, { once: true });
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.connected = false;
      this.events?.abort();
      this.visibility?.disconnect();
      this.entries.forEach(entry => {
        clearTimeout(entry.timer);
        this.pause(entry);
        entry.slot.appendChild(entry.media);
        if (entry.toggle) entry.toggle.hidden = true;
      });
    }
  }

  customElements.define('omri-how-accordion', OmriHowAccordion);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omri-personnalisation-photo"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'omri-personnalisation-accordion-v7';
  if (customElements.get(tag)) return;
  class OmriPhotoAccordion extends HTMLElement {
    connectedCallback() {
      if (this.events || this.mountFrame || this.mountObserver) return;
      const mountWhenReady = () => {
        if (!this.isConnected) return;
        const expected = Number(this.dataset.stepCount) || 0;
        if (!this.querySelector('[data-frame]') || this.querySelectorAll('[data-step]').length !== Math.max(1,expected)
          || this.querySelectorAll('[data-goto]').length !== expected || this.querySelectorAll('[data-body]').length !== expected) return;
        this.mountObserver?.disconnect(); this.mountObserver = null;
        this.mount();
      };
      this.mountFrame = requestAnimationFrame(() => {
        this.mountFrame = null;
        if (!this.isConnected) return;
        this.mountObserver = new MutationObserver(mountWhenReady);
        this.mountObserver.observe(this,{ childList:true,subtree:true });
        mountWhenReady();
      });
    }
    mount() {
      if (this.events) return;
      this.events = new AbortController(); const signal = this.events.signal;
      this.slides = [...this.querySelectorAll('[data-step]')];
      this.sharedMedia = this.querySelector('[data-shared-media]');
      this.mediaSlides = this.sharedMedia ? [...this.slides, this.sharedMedia] : this.slides;
      this.triggers = [...this.querySelectorAll('[data-goto]')];
      this.items = [...this.querySelectorAll('[data-item]')];
      this.bodies = [...this.querySelectorAll('[data-body]')];
      this.frame = this.querySelector('[data-frame]');
      this.panel = this.querySelector('.omri-perso-photo__panel');
      this.accordion = this.querySelector('[data-accordion]');
      this.status = this.querySelector('[data-status]');
      this.index = 0; this.generation = 0; this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.accordion?.classList.remove('is-ready');
      this.updateAccordion(); this.finish();
      this.readyFrame = requestAnimationFrame(() => {
        this.readyFrame = null;
        this.readyNextFrame = requestAnimationFrame(() => {
          this.readyNextFrame = null; this.accordion?.classList.add('is-ready');
        });
      });
      this.triggers.forEach((trigger,i) => trigger.addEventListener('click', () => this.select(i), { signal }));
      this.panel.addEventListener('pointerdown',event => this.startSwipe(event),{ signal });
      this.panel.addEventListener('pointermove',event => this.moveSwipe(event),{ passive:false,signal });
      this.panel.addEventListener('pointerup',event => this.endSwipe(event),{ signal });
      this.panel.addEventListener('pointercancel',() => this.cancelSwipe(),{ signal });
      this.panel.addEventListener('lostpointercapture',() => this.cancelSwipe(),{ signal });
      this.panel.addEventListener('click',event => {
        if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      },{ capture:true,signal });
      this.panel.addEventListener('dragstart',event => {
        if (event.target.closest('img,video')) event.preventDefault();
      },{ signal });
      this.addEventListener('keydown', event => {
        const trigger = event.target.closest('[data-goto]');
        if (!trigger || event.altKey || event.ctrlKey || event.metaKey) return;
        const current = this.triggers.indexOf(trigger); let next;
        if (event.key === 'ArrowDown') next = (current + 1) % this.triggers.length;
        else if (event.key === 'ArrowUp') next = (current + this.triggers.length - 1) % this.triggers.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.triggers.length - 1;
        else return;
        event.preventDefault(); this.triggers[next].focus({ preventScroll:true });
      }, { signal });
      this.mediaSlides.forEach(slide => {
        const video = slide.querySelector('video');
        const button = slide.querySelector('[data-video-toggle]');
        if (!video || !button) return;
        video.defaultMuted = false;
        video.muted = false;
        video.controls = false;
        this.updateVideoButton(slide,false);
        button.addEventListener('click', () => this.toggleVideo(slide), { signal });
        video.addEventListener('playing', () => {
          if (!this.isMediaActive(slide) || document.hidden) { video.pause(); return; }
          video.classList.add('is-ready');
          this.updateVideoButton(slide,true);
        }, { signal });
        video.addEventListener('pause', () => this.updateVideoButton(slide,false), { signal });
        video.addEventListener('ended', () => this.updateVideoButton(slide,false), { signal });
        video.addEventListener('error', () => {
          video.classList.remove('is-ready');
          this.updateVideoButton(slide,false);
        }, { signal });
      });
      this.motion.addEventListener('change', () => { this.finish(); this.syncVideo(); }, { signal });
      document.addEventListener('visibilitychange', () => this.syncVideo(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const item = event.target.closest?.('[data-item]');
        if (item && this.contains(item)) this.select([...this.querySelectorAll('[data-item]')].indexOf(item));
      }, { signal });
      const measure = () => this.measure();
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(measure);
        [this.frame, ...this.querySelectorAll('[data-body-content]'), ...this.triggers].forEach(element => this.resize.observe(element));
      }
      window.addEventListener('resize', measure, { passive:true, signal });
      document.fonts?.addEventListener('loadingdone', measure, { signal });
      this.measure();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting); this.syncVideo();
        }, { threshold:0 });
        // Avec une vidéo commune, observer la section entière : sur mobile,
        // ouvrir une question plus bas ne coupe pas le son dès que la vidéo sort du cadre.
        this.observer.observe(this.sharedMedia ? this : this.frame);
      } else { this.visible = true; this.syncVideo(); }
    }
    startSwipe(event) {
      if (event.isPrimary === false || (event.button !== undefined && event.button !== 0) || this.triggers.length < 2
        || event.target.closest('button,a,input,textarea,select,[contenteditable="true"]')) return;
      this.suppressClickUntil = 0;
      this.gesture = { id:event.pointerId,x:event.clientX,y:event.clientY,axis:null };
    }
    moveSwipe(event) {
      const gesture = this.gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x,dy = event.clientY - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx),Math.abs(dy)) > 10) {
        if (Math.abs(dy) >= Math.abs(dx)) { this.cancelSwipe(); return; }
        if (Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        gesture.axis = 'horizontal'; this.panel.classList.add('is-swiping');
        // Capture only after an actual horizontal drag, so a normal tap still clicks its header/link.
        try { this.panel.setPointerCapture(event.pointerId); } catch (_) {}
      }
      if (gesture.axis === 'horizontal' && event.cancelable) event.preventDefault();
    }
    endSwipe(event) {
      const gesture = this.gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x,dy = event.clientY - gesture.y;
      const horizontal = Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25;
      const dragged = gesture.axis === 'horizontal';
      this.cancelSwipe();
      if (dragged || horizontal) this.suppressClickUntil = performance.now() + 450;
      if (horizontal) this.select(Math.max(0,Math.min(this.triggers.length - 1,this.index + (dx < 0 ? 1 : -1))));
    }
    cancelSwipe() {
      const id = this.gesture?.id;
      this.gesture = null; this.panel?.classList.remove('is-swiping');
      if (id !== undefined) {
        try { if (this.panel.hasPointerCapture(id)) this.panel.releasePointerCapture(id); } catch (_) {}
      }
    }
    measure() {
      const width = this.frame.getBoundingClientRect().width;
      const pad = this.dataset.frameBackground === 'white' ? parseFloat(getComputedStyle(this).getPropertyValue('--omri-panel-pad')) || 0 : 0;
      if (width > 0) this.querySelectorAll('img').forEach(image => image.sizes = `${Math.max(1, Math.ceil(width - 2 * pad))}px`);
    }
    finish() {
      clearTimeout(this.timer); cancelAnimationFrame(this.raf); this.generation++;
      this.slides.forEach((slide,i) => {
        slide.style.transition = 'none'; slide.style.transform = 'translateX(0)';
        slide.hidden = i !== this.index; slide.inert = i !== this.index;
        slide.toggleAttribute('inert',i !== this.index);
        slide.setAttribute('aria-hidden',String(i !== this.index));
      });
    }
    select(next) {
      if (!Number.isInteger(next) || next < 0 || next >= this.triggers.length || next === this.index) return;
      this.finish();
      const old = this.slides[this.index], incoming = this.slides[next];
      const direction = next > this.index ? 1 : -1;
      this.index = next;
      old.inert = true; old.setAttribute('inert',''); old.setAttribute('aria-hidden','true');
      incoming.hidden = false; incoming.inert = false; incoming.removeAttribute('inert'); incoming.setAttribute('aria-hidden','false');
      this.updateAccordion();
      if (this.status) this.status.textContent = `Étape ${next + 1} sur ${this.slides.length}${incoming.dataset.name ? ' : ' + incoming.dataset.name : ''}`;
      this.syncVideo();
      if (this.motion.matches) { this.finish(); return; }
      incoming.style.transform = `translateX(${direction * 100}%)`; old.style.transform = 'translateX(0)';
      void incoming.offsetWidth;
      const generation = this.generation;
      this.raf = requestAnimationFrame(() => {
        if (generation !== this.generation) return;
        incoming.style.transition = ''; old.style.transition = '';
        incoming.style.transform = 'translateX(0)'; old.style.transform = `translateX(${-direction * 100}%)`;
        this.timer = setTimeout(() => { if (generation === this.generation) this.finish(); },650);
      });
    }
    updateAccordion() {
      // Les rubriques sont toujours ouvertes : le clic change uniquement le visuel.
      this.items.forEach(item => item.classList.add('is-open'));
      this.bodies.forEach(body => {
        body.inert = false; body.removeAttribute('inert');
        body.removeAttribute('aria-hidden');
      });
    }
    usesShared(index) {
      return !!this.sharedMedia && this.slides[index]?.dataset.useShared === 'true';
    }
    isMediaActive(slide) {
      if (slide === this.sharedMedia) return this.usesShared(this.index);
      return this.slides[this.index] === slide && !this.usesShared(this.index);
    }
    updateVideoButton(slide,playing) {
      const button = slide.querySelector('[data-video-toggle]');
      if (!button) return;
      slide.classList.toggle('is-playing',playing);
      button.setAttribute('aria-pressed',String(playing));
      const name = slide.dataset.name ? ` : ${slide.dataset.name}` : '';
      button.setAttribute('aria-label',`${playing ? 'Mettre en pause' : 'Lire'} la vidéo${name}`);
    }
    toggleVideo(slide) {
      const video = slide.querySelector('video');
      if (!video || !this.isMediaActive(slide) || document.hidden) return;
      if (!video.paused && !video.ended) { video.pause(); return; }
      // Chargement différé : le clic utilisateur déclenche directement la lecture avec son.
      if (!video.dataset.loaded) {
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.dataset.loaded = 'true';
        video.load();
      }
      video.defaultMuted = false;
      video.muted = false;
      video.volume = 1;
      try {
        const attempt = video.play();
        if (attempt?.catch) attempt.catch(() => this.updateVideoButton(slide,false));
      } catch (_) { this.updateVideoButton(slide,false); }
    }
    syncVideo() {
      // La vidéo commune n'est ni recréée, ni mise en pause, ni remise à zéro
      // quand deux questions successives utilisent cette même vidéo.
      if (this.sharedMedia) {
        const showShared = this.usesShared(this.index);
        this.sharedMedia.hidden = !showShared;
        this.sharedMedia.inert = !showShared;
        this.sharedMedia.toggleAttribute('inert', !showShared);
        this.sharedMedia.setAttribute('aria-hidden', String(!showShared));
      }
      this.mediaSlides.forEach(slide => {
        const video = slide.querySelector('video'); if (!video) return;
        const active = this.isMediaActive(slide);
        if (!active || !this.visible || document.hidden) {
          if (!video.paused) video.pause();
        }
        // Une vidéo propre à une étape repart du début lorsqu'on quitte celle-ci.
        // La vidéo commune conserve sa position, même après une étape spécifique.
        if (!active && slide !== this.sharedMedia && video.dataset.loaded) {
          try { if (video.readyState > 0) video.currentTime = 0; } catch (_) {}
          video.classList.remove('is-ready');
          this.updateVideoButton(slide,false);
        }
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.mountFrame); this.mountFrame = null;
      this.mountObserver?.disconnect(); this.mountObserver = null;
      this.cancelSwipe();
      cancelAnimationFrame(this.readyFrame); cancelAnimationFrame(this.readyNextFrame);
      this.accordion?.classList.remove('is-ready');
      if (this.slides) this.finish(); this.events?.abort(); this.events = null;
      this.resize?.disconnect(); this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  }
  customElements.define(tag,OmriPhotoAccordion);
})();

  } catch(e) { console.error(e); }
})();
})();
